import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

const getUsProviderGroupClinicsQueryKey = () => ["getUsProviderGroupClinics"] as const;

export const useGetUsProviderGroupClinics = () => {
  const client = useApiClient();

  return useQuery(getUsProviderGroupClinicsQueryKey(), () => client.getUsProviderGroupClinics());
};
